var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesignPresets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 41,
    viewBox: "0 0 48 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Glyph",
    transform: "translate(-0.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    className: "cls-1",
    transform: "translate(0.435)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 48,
    height: 41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    transform: "translate(39.064 132.791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    transform: "translate(-8.839 -112.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    className: "cls-2",
    d: "M8-104.043H4.39a.574.574,0,0,1-.574-.574.574.574,0,0,1,.574-.574H8a.574.574,0,0,1,.574.574A.574.574,0,0,1,8-104.043Z",
    transform: "translate(-3.816 105.191)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    transform: "translate(-25.897 -112.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    className: "cls-2",
    d: "M-12.857-104.043H-25.323a.574.574,0,0,1-.574-.574.574.574,0,0,1,.574-.574h12.466a.574.574,0,0,1,.574.574A.574.574,0,0,1-12.857-104.043Z",
    transform: "translate(25.897 105.191)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    transform: "translate(-13.431 -115.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    className: "cls-2",
    d: "M-1.313-103.45a2.873,2.873,0,0,1-2.87-2.87,2.874,2.874,0,0,1,2.87-2.871,2.874,2.874,0,0,1,2.871,2.871A2.874,2.874,0,0,1-1.313-103.45Zm0-4.593a1.724,1.724,0,0,0-1.722,1.723A1.724,1.724,0,0,0-1.313-104.6a1.724,1.724,0,0,0,1.722-1.722A1.725,1.725,0,0,0-1.313-108.044Z",
    transform: "translate(4.183 109.192)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    transform: "translate(-17.699 -120.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    className: "cls-2",
    d: "M1.424-118.046H-11.043a.574.574,0,0,1-.574-.574.574.574,0,0,1,.574-.574H1.424A.574.574,0,0,1,2-118.62.574.574,0,0,1,1.424-118.046Z",
    transform: "translate(11.617 119.194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    transform: "translate(-25.897 -120.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    className: "cls-2",
    d: "M-21.715-118.046h-3.608a.574.574,0,0,1-.574-.574.574.574,0,0,1,.574-.574h3.608a.574.574,0,0,1,.574.574A.574.574,0,0,1-21.715-118.046Z",
    transform: "translate(25.897 119.194)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    transform: "translate(-22.289 -123.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    className: "cls-2",
    d: "M-16.743-117.452a2.873,2.873,0,0,1-2.869-2.871,2.872,2.872,0,0,1,2.869-2.869,2.873,2.873,0,0,1,2.869,2.869A2.873,2.873,0,0,1-16.743-117.452Zm0-4.592a1.723,1.723,0,0,0-1.721,1.721,1.724,1.724,0,0,0,1.721,1.722,1.724,1.724,0,0,0,1.721-1.722A1.723,1.723,0,0,0-16.743-122.044Z",
    transform: "translate(19.612 123.192)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    transform: "translate(-13.269 -104.821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    className: "cls-2",
    d: "M4.711-90.044H-3.327a.574.574,0,0,1-.574-.574.574.574,0,0,1,.574-.574H4.711a.574.574,0,0,1,.574.574A.574.574,0,0,1,4.711-90.044Z",
    transform: "translate(3.901 91.192)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    transform: "translate(-25.897 -104.821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    className: "cls-2",
    d: "M-17.285-90.044h-8.037a.574.574,0,0,1-.574-.574.574.574,0,0,1,.574-.574h8.037a.574.574,0,0,1,.574.574A.574.574,0,0,1-17.285-90.044Z",
    transform: "translate(25.897 91.192)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    transform: "translate(-17.86 -107.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    className: "cls-2",
    d: "M-9.028-89.449a2.873,2.873,0,0,1-2.869-2.87A2.873,2.873,0,0,1-9.028-95.19a2.873,2.873,0,0,1,2.87,2.871A2.873,2.873,0,0,1-9.028-89.449Zm0-4.593a1.724,1.724,0,0,0-1.721,1.722A1.724,1.724,0,0,0-9.028-90.6a1.724,1.724,0,0,0,1.722-1.722A1.724,1.724,0,0,0-9.028-94.042Z",
    transform: "translate(11.897 95.19)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignPresets);
export default __webpack_public_path__ + "static/media/design-presets.582d2859.svg";
export { ForwardRef as ReactComponent };